import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import im1 from "../assets/images/im26.jpg";

const brands = [
  "Lenses....Zeiss",
  "Essilor",
  "Rodenstock",
  "Vision Rx",
  "Nova",
  "Kodak",
  "Vogue",
  "Tom Ford",
  "Ray-Ban",
  "Carrera",
  "Police",
  "Boss",
  "Mont Blanc",
];



export default function b1pages() {
  return (
    <>
      <Header />
      <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #d0eaff, white)",
        padding: "20px",
      }}
    >
      {/* Header Section */}
      <header style={{ textAlign: "center", marginBottom: "20px" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#000",
            marginBottom: "10px",
          }}
        >
          Ways To Prevent Eye Problems 

        </h1>
        <p style={{ fontSize: "1rem", color: "gray" }}>
        Protect Your Vision &bull; Prioritize Your Eye Health
        </p>
      </header>

      {/* Image Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          maxWidth: "800px",
          width: "100%",
        }}
      >
        <img
          src={im1} // Replace with the actual image path
          alt="Eye checkup services"
          style={{ width: "100%", height: "auto", borderRadius: "10px" }}
        />
      </div>

      
    </div>
    <div
      style={{
        maxWidth: "800px",
        margin: "40px auto",
        padding: "0 20px",
        fontFamily: "'Georgia', serif",
        lineHeight: "1.8",
        color: "#333",
      }}
    >
      {/* Title Section */}
      <h1
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          marginBottom: "20px",
          color: "#2d2d2d",
        }}
      >
        How to Prevent Eye Problems?
      </h1>

      {/* Content Section */}
      <p style={{ marginBottom: "20px" }}>
      Regular eye exams Reduce screen time-Follow 20-20-20 rule (every 20 minutes look at something 20 feet away for at least 20 seconds) 
      Taking regular breaks during near work activities & consistently using prescribed spectacles or other optical interventions 
      </p>

      <p style={{ marginBottom: "20px" }}>
      Distance between the eyes & the book is at least 30cm. Proper lighting, Blink consciously, Eye exercise,
      Good eye hygiene, Know about hereditary conditions, Outdoor activities - spending at least 90 minutes outdoor during daylight hours.
      </p>

      <p style={{ marginBottom: "20px" }}>
      Protecting your eyes from harmful UV rays. Diet & Nutrition ( Vitamin A,C,E, Minerals,Zinc,Omega 3 fatty acids,Leafy green,Carrots,Fish ),
      Staying hydrated, Get enough sleep, Don’t smoke.
      </p>
    </div>
      <Footer />
    </>
  );
}
